import React from "react";
import { makeStyles } from "@mui/styles";
import alpaagoIcon from "../../assets/Images/aplaago.png";
import { Link, useNavigate } from "react-router-dom";
import { RootNavTabs } from "../../data/RootNavTabs";
import { routes } from "../../routing/routes";

const customStyles = makeStyles({
  root: {
    maxWidth: "100vw",
    width: "100%",
    position: "sticky",
    top: "0",
    transition: "all .4s ease",
    willChange: "unset",
    backgroundClip: "padding-box",
    position: "relative",
    zIndex: 2,
    fontFamily: "Montserrat",

  },
  navWrapper: {
    padding: "0 70px",
    display: "flex",
  },
  iconWrapper: {
    margin: "24px 0px",
    height: "15px",
  },
  alpaagoIcon: {
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0",
    right: "0",
    transition: "all .2s ease",
    height: "64px",
    marginLeft:"10px"
  },
  navBar: {
    display: "flex",
    flex: "1",
    justifyContent: "space-between",
    marginLeft: "140px",
  },
  navLinks: {
    display: "flex",
    flex: "1",
    justifyContent: "flex-start",
  },
  tabUL: {
    display: "flex",
    listStyle: "none",
    margin: "0",
    padding: "0",
    boxSizing: "border-box",
    gap: "42px",
     color: "white",
        fontFamily: "Montserrat",
  },
  tabLI: {
    alignItems: "center",
    display: "flex",
    listStyle: "none",
    margin: "0",
    padding: "0",
     color: "white",
        fontFamily: "Montserrat",
  },
  tabA: {
    transition: "all .2s ease",
    display: "block",
    cursor: "pointer",
    textDecoration: "none",
    fontWeight: "600",
 color: "black",
        fontFamily: "Montserrat",
        },
  navBtn: {
    alignItems: "center",
    display: "flex",
  },
  // Targeting very small mobile devices or feature phones (e.g., early Nokia phones, very small Android phones)
  '@media (max-width: 319px)': {
    navWrapper: {
      marginTop:"30px",
      padding: "10 5px",
      flexDirection: "column",  
          fontFamily: "Montserrat",

    },
    tabUL: {
      display: "flex",
      gap: "10px", 
      flexWrap: "wrap",  
          fontFamily: "Montserrat",

    },
    tabA: {
      fontSize: "10px", 
          fontFamily: "Montserrat",
 
    },
    navBtn: {
      fontSize: "10px",
      marginLeft:"-50px",
      marginTop:"10px",
          fontFamily: "Montserrat",

    },
    alpaagoIcon: {
      height: "40px", 
     marginTop:"10px"

    },
  },

  // Targeting small smartphones or older mobile devices (e.g., iPhone 5/5S, Samsung Galaxy S4, HTC One)
  '@media (min-width: 320px) and (max-width: 480px)': {
    navWrapper: {
      marginTop:"30px",
      padding: "0 10px",
      flexDirection: "column",
          fontFamily: "Montserrat",

    },
    tabUL: {
      gap: "20px", 
      marginLeft:"-140px",
        zIndex: 0,  
        fontFamily: "Montserrat",


    },
    tabA: {
      fontSize: "12px", 
          fontFamily: "Montserrat",

    },
    navBtn: {
      fontSize: "10px",
      marginTop:"-115px",
      marginLeft:"-200px",
      fontFamily: "Montserrat",
    },
    signupBtn: {
      position: "relative", 
      zIndex: 1,  
      fontFamily: "Montserrat",
    },
    alpaagoIcon: {
      height: "65px", 
      marginTop:"10px"
    },
  },

  // Targeting mid-sized smartphones and small tablets (e.g., iPhone 6/7/8, iPad Mini, Nexus 7, Samsung Galaxy Tab)
  '@media (min-width: 481px) and (max-width: 768px)': {
    navWrapper: {
      marginTop:"30px",
      padding: "0 15px",
      flexDirection: "column",
      fontFamily: "Montserrat",
    },
    tabUL: {
      gap: "25px",  
fontFamily: "Montserrat",
    },
    tabA: {
      fontSize: "6px", 
      marginLeft:"-20px",
      fontFamily: "Montserrat",
    },
    navBtn: {
      fontSize: "4px",
      marginTop:"-115px",
      fontFamily: "Montserrat",

    },
    alpaagoIcon: {
      height: "60px", 
       marginTop:"10px"

    },
  },

  // Targeting tablets in landscape mode, small laptops, and some large tablets (e.g., iPad Pro, MacBook Air 11", Samsung Galaxy Tab S4)
  '@media (min-width: 769px) and (max-width: 1024px)': {
    navWrapper: {
      padding: "0 20px",
      flexDirection: "row",
      marginTop:"30px",
      fontFamily: "Montserrat",
  
    },
    tabUL: {
      gap: "300px", 
      fontFamily: "Montserrat",
    },
    tabA: {
      fontSize: "16px",  
      fontFamily: "Montserrat",
    },
    navBtn: {
      fontSize: "16px",
       marginTop:"-115px",
      fontFamily: "Montserrat",       
    },
    alpaagoIcon: {
      height: "70px",
       marginTop:"10px"
 
    },
  },
});

const RootTopBar = () => {
  const navigate = useNavigate();
  const classes = customStyles();

  return (
    <div className={classes.root}>
      <div className={classes.navWrapper}>
        <div className={classes.iconWrapper}>
          <img
            className={classes.alpaagoIcon}
            src={alpaagoIcon}
            alt="Description of the image"
          />
        </div>
        <div className={classes.navBar}>
          <div className={classes.navLinks}>
            <ul className={classes.tabUL}>
              {RootNavTabs.map((tab) => (
                <li key={tab.id} className={classes.tabLI}>
                  <Link to={tab.tabUrl} className={classes.tabA}>
                    <span>{tab.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className={classes.navBtn}>
            <div
            style={{ backgroundColor: "black",
        fontFamily: "Montserrat",color:"white"}}
              className={"purpleBtn"}
              onClick={() => {
                navigate(routes.SIGN_UP);
              }}
            >
              Sign Up
            </div>
          </div>
        
        </div>
      </div>
    </div>
  );
};

export default RootTopBar;
